import { render, staticRenderFns } from "./AttachmentUpload.vue?vue&type=template&id=1b90c8d4&scoped=true&"
import script from "./AttachmentUpload.vue?vue&type=script&lang=js&"
export * from "./AttachmentUpload.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentUpload.vue?vue&type=style&index=0&id=1b90c8d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b90c8d4",
  null
  
)

export default component.exports